import React from 'react';

const RenderedComponentLog = [];
const WRAPPED_SYMBOL = Symbol('lifecycle_wrapped');

const addToLog = (component) => {
  RenderedComponentLog.push(component);
  if (RenderedComponentLog.length > 20) {
    RenderedComponentLog.shift();
  }
};

export default class LogictryComponent extends React.PureComponent {
  constructor(props) {
    super(props);
    this._instrumentLifecycle();
  }

  _instrumentLifecycle() {
    const proto = Object.getPrototypeOf(this);

    if (proto[WRAPPED_SYMBOL]) return;
    proto[WRAPPED_SYMBOL] = true;

    const wrap = (methodName, wrapperFn) => {
      const original = proto[methodName];
      proto[methodName] = function (...args) {
        try {
          wrapperFn.call(this, ...args);
        } catch {
          //
        }
        if (typeof original === 'function') {
          return original.apply(this, args);
        }
      };
    };

    wrap('componentDidMount', function () {
      addToLog(`[MOUNT] ${this.constructor.name}`);
      // addToLog(`[MOUNT] ${this.constructor.name} ${JSON.stringify({
      //   props: this.props,
      //   state: this.state,
      // })}`);
    });

    wrap('componentDidUpdate', function () {
      addToLog(`[UPDATE] ${this.constructor.name}`);
    });

    wrap('componentWillUnmount', function () {
      addToLog(`[UNMOUNT] ${this.constructor.name}`);
    });

    wrap('render', function () {
      addToLog(`[RENDER] ${this.constructor.name}`);
    });
  }
}

export function getLast10RenderedComponents() {
  return [...RenderedComponentLog];
}
